// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import "swiper/css/effect-coverflow";

// import required modules
import { EffectCreative, Autoplay } from "swiper/modules";
import React, {ReactNode} from "react";
import OneCard from "./OneCard";

interface IOneDataAna{
    title:string;
    content:ReactNode;
}

interface IDataAnaMobile{
    list:IOneDataAna[];
}

export default function DataAnaMobile(props:IDataAnaMobile){
    const {list } = props;
    return (
        <>
            <Swiper
                effect={"creative"}
                grabCursor={true}
                centeredSlides={true}
                slidesPerView={"auto"}
                // initialSlide={1}
                autoplay={true}
                creativeEffect={{
                    prev: {
                        // shadow: true,
                        translate: [-80, 0, 0],
                        scale: 0.8,
                    },
                    next: {
                        translate: [80, 0, 0],
                        scale: 0.8
                    }
                }}
                modules={[EffectCreative,Autoplay]}
                className="data-ana-mobile my-swiper-wrapper"
            >
                {list.map((one,index)=>(
                    <SwiperSlide key={index}>
                        <OneCard title={one.title} content={one.content} />
                    </SwiperSlide>
                ))}
            </Swiper>
        </>
    )
}
